import React, { useEffect, useState } from 'react';
import {
  Tab,
  TabContainer,
  TabContents,
  TabLink,
  TabNavigation,
} from '../../../components/common/tabs/tab-container';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { EQUIPMENT_LIST_INDEX } from '../../../router/routes';
import { route } from '../../../services/utils';
import EquipmentListTab from './list';
import { EquipmentType } from '../../../enums/equipment-type';
import ShowIfAllowed from '../../../components/common/show-if-allowed';
import Title from '../../../components/common/title';

export default function EquipmentList() {
  const { t } = useTranslation();

  // get URL param and initialize default tab based on it
  const { farmId, equipmentType } = useParams<{
    farmId: string;
    equipmentType: string;
  }>();
  const [currentTab, setTab] = useState(equipmentType);

  // set URL parameter when tab is changed within history
  const history = useHistory();
  useEffect(() => {
    const routeTo = route(EQUIPMENT_LIST_INDEX, {
      farmId: farmId,
      equipmentType: currentTab,
    });
    history.push(routeTo);
  }, [history, equipmentType, currentTab, farmId]);

  return (
    <>
      <Title title={t('pages.equipment.list.title')}></Title>
      <TabContainer
        selectedTabKey={currentTab}
        setTab={setTab}
        tabNavigation={
          <TabNavigation>
            <ShowIfAllowed ability={{ entity_type: 'equipment' }}>
              <TabLink tabKey={EquipmentType.selfPropelledMachinery}>
                {t('pages.equipment.self_propelled_machinery.title')}
              </TabLink>
              <TabLink tabKey={EquipmentType.machinesAndAggregates}>
                {t('pages.equipment.machines_and_aggregates.title')}
              </TabLink>
            </ShowIfAllowed>
          </TabNavigation>
        }
        tabContents={
          <TabContents>
            <ShowIfAllowed ability={{ entity_type: 'equipment' }}>
              <Tab tabKey={EquipmentType.selfPropelledMachinery}>
                <EquipmentListTab
                  farmId={farmId}
                  equipmentType={EquipmentType.selfPropelledMachinery}
                />
              </Tab>
              <Tab tabKey={EquipmentType.machinesAndAggregates}>
                <EquipmentListTab
                  farmId={farmId}
                  equipmentType={EquipmentType.machinesAndAggregates}
                />
              </Tab>
            </ShowIfAllowed>
          </TabContents>
        }
      />
    </>
  );
}
